"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _carbonComponentsReact = require("carbon-components-react");
var _Overlay = _interopRequireDefault(require("../Overlay/Overlay"));
var _RadioButtons = _interopRequireDefault(require("../RadioButtons/RadioButtons"));
var _Link = _interopRequireDefault(require("../Link/Link"));
var _Button = require("../Button/Button");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = "#privacy-policy-notification .bx--toast-notification--info {\n  border-left-color: #e41b13;\n  background: #f4f4f4;\n  max-width: 272px; }\n\n#privacy-policy-notification .bx--toast-notification--info {\n  margin: 0 16px; }\n  #privacy-policy-notification .bx--toast-notification--info .bx--toast-notification__icon {\n    fill: #e41b13; }\n\n#privacy-policy-notification .bx--toast-notification__title {\n  font-weight: normal;\n  color: #e41b13;\n  margin-bottom: 16px; }\n\n#privacy-policy-notification .bx--toast-notification__subtitle {\n  margin: 0; }\n\n#privacy-policy-notification .bx--toast-notification__details {\n  margin-right: 0; }\n\n#privacy-policy-notification .radio-buttons {\n  margin-left: -37px;\n  padding-right: 52px; }\n  #privacy-policy-notification .radio-buttons .bx--radio-button__appearance {\n    margin-right: 16px; }\n  #privacy-policy-notification .radio-buttons label {\n    margin-bottom: 24px;\n    color: #4c4c4c; }\n\n#privacy-policy-notification a {\n  margin-bottom: 16px;\n  color: #000000; }\n\n#privacy-policy-notification button {\n  margin-bottom: 24px; }\n";
  const fileName = "PrivacyPolicyNotification_PrivacyPolicyNotification";
  const element = document.querySelector("style[data-sass-component='PrivacyPolicyNotification_PrivacyPolicyNotification']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const PrivacyPolicyNotification = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    id: 'privacy-policy-notification'
  }, /*#__PURE__*/_react.default.createElement(_Overlay.default, null, /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.ToastNotification, {
    hideCloseButton: true,
    kind: 'info',
    title: props.labels.privacyPolicy
  }, /*#__PURE__*/_react.default.createElement(_RadioButtons.default, {
    name: 'answer',
    onChange: props.onChangeAnswer,
    selectedValue: props.answer,
    items: [{
      value: 'yes',
      label: props.labels.yes
    }, {
      value: 'no',
      label: props.labels.no
    }]
  }), /*#__PURE__*/_react.default.createElement(_Link.default, {
    target: props.linkUrl,
    withIcon: true
  }, props.labels.privacyPolicy), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    onClick: props.onSubmit,
    disabled: !props.answer
  }, props.labels.submit))));
};
PrivacyPolicyNotification.propTypes = {
  labels: _propTypes.default.object.isRequired,
  linkUrl: _propTypes.default.string.isRequired,
  answer: _propTypes.default.string,
  onChangeAnswer: _propTypes.default.func.isRequired,
  onSubmit: _propTypes.default.func.isRequired
};
var _default = exports.default = PrivacyPolicyNotification;